export const unassignedFilterInstallationInitialValues = {
	number: "",
	mid: "",
	merchant_name: "",
	agent_office: "",
	agent_name: "",
	terminal_number: "",
};

export const inProgressFilterInstallationInitialValues = {
	number: "",
	mid: "",
	merchant_name: "",
	agent_office: "",
	agent_name: "",
	terminal_number: "",
	assignedTo: "",
};

export const pendedFilterInstallationInitialValues = {
	number: "",
	mid: "",
	merchant_name: "",
	agent_office: "",
	agent_name: "",
	terminal_number: "",
	pendStatus: "",
	pendedTo: "",
	assignedTo: "",
};

export const completeFilterInstallationInitialValues = {
	number: "",
	mid: "",
	merchant_name: "",
	agent_office: "",
	agent_name: "",
	terminal_number: "",
};
